/**
 * Ad / IAP analytics — one action out to the host app.
 *
 * ❓ PLACEHOLDER — not in the decomp (the shipped game logs through ElephantSDK
 * in-process). Shape from `reference/DiceFlow/index.html`, see
 * `web/docs/ADS-MONETIZATION.md` §A.2.5.
 *
 * The three interstitial events are deliberate: without `request` alongside
 * `shown` there is no fill rate, and "ads never appear" becomes undebuggable.
 */

import { nativeBridge, type NativeBridge } from './bridge'

export type MonetizationEvent =
  | 'interstitial_request'
  | 'interstitial_shown'
  | 'interstitial_no_fill'
  | 'remove_ads_open'
  | 'remove_ads_start'
  | 'remove_ads_result'
  | 'remove_ads_restore'

export class MonetizationAnalytics {
  constructor(private readonly bridge: NativeBridge = nativeBridge) {}

  log(eventName: MonetizationEvent, level: number, params?: Record<string, unknown>): void {
    const payload: Record<string, unknown> = { eventName, currentLevel: level }
    if (params && Object.keys(params).length > 0) payload.params = params
    this.bridge.send('log_action', payload)
  }
}

export const monetizationAnalytics = new MonetizationAnalytics()
